import type { TooltipProps } from '../../../core/slots/Tooltip.js';
import type { ChartDatapoint } from '../../../core/types/chart-data.js';

/**
 * @internal
 */
export const FlameChartTooltipSlot = function <TData extends ChartDatapoint>(
  _props: TooltipProps<TData>,
): null {
  return null;
};
FlameChartTooltipSlot.displayName = 'FlameChart.Tooltip';
/**
 * @internal
 */
export const FlameGraphTooltipSlot = function <TData extends ChartDatapoint>(
  _props: TooltipProps<TData>,
): null {
  return null;
};
FlameGraphTooltipSlot.displayName = 'FlameGraph.Tooltip';
